import { render, staticRenderFns } from "./Notario.vue?vue&type=template&id=3839c9b7"
import script from "./Notario.vue?vue&type=script&lang=js"
export * from "./Notario.vue?vue&type=script&lang=js"
import style0 from "./Notario.vue?vue&type=style&index=0&id=3839c9b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports